import HomePage from '../pages/HomePage/HomePage';
import SearchResultPage from './../pages/SeachResultPage/SearchResultPage'
import Review from './../containers/Review/Review';
import getQueryString from './../utils/QueryValue';
import format_BusQueryDate from '../utils/QueryDateFormat';
import format_dateObj from './../utils/FormatDateObj';
import getDateObj from '../utils/GetDateObj';
import tvcQueryParameters from './../utils/SEMParmaters';
import dateformat from 'dateformat';
import {updateJourneyParams} from './../containers/Common/redux/actions'
import {setVerticalFooterDataFromPageRover} from '@stencil/footer/src/footer-data';
import {updateRouteId,updateRTCView,updateSortBy} from './../containers/SRP/redux/actions';
import {redisConfig} from './../config/infraConfig';
import {
  getKey as getKeyFromRedis,
  setKey as setKeyForRedis
} from '@stencil/external-inmemory-key-value-cache';
import {pushDataToNewrelicFromServer,getfooterRedisKey} from './../containers/Common/Utils';
import AlternateRoutesUI from './../containers/SRP/AlternateRoutesUI';
import {updateFooterData,updateHomePageContent} from './../containers/Common/redux/actions';
import ThankyouPage from './../containers/ThankyouPage/ThankyouPage'
import {updateThankyouPageURLParams} from './../containers/ThankyouPage/redux/actions';
import { updateFAQDATA } from '../containers/Home/redux/actions';
import { fetchFAQData } from '../containers/Home/redux/thunks';

export default [
  {
    path: ['/sbus/','/bus/'],
    component: HomePage,
    key: 'HomePage',
    onServerInit: () => {
      fetchFooterData();
    },
  
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const urlstr = decodeURIComponent(searchString);
      let src = getQueryString('src',urlstr);
      let dest = getQueryString('dest',urlstr);
      let src_id = getQueryString('src_id',urlstr);
      let dest_id = getQueryString('dest_id',urlstr);
      let onwDate = getQueryString('onwDate',urlstr);
      let offsetDate = getQueryString('offsetDate',urlstr);
      let others = getQueryString('others',urlstr);
      let busType = getQueryString('busType',urlstr);
      const {dateStr,dateObject } = function(){
        let dateObj = getDateObj();
        if(onwDate && onwDate.toLowerCase() !== "na"){
          dateObj = getDateObj(format_BusQueryDate(onwDate))
        }
        if(offsetDate && Number.isInteger(+offsetDate) && +offsetDate > 0){
        
          dateObj.setDate(dateObj.getDate() + (+offsetDate));
        }
        return {dateStr:dateformat(dateObj,'yyyymmdd'),dateObject:dateObj};
      }()
      dispatch(updateJourneyParams({
        src,
        dest,
        src_vid:src_id,
        dest_vid:dest_id,
        doj:dateStr,
        journeyType: 'onw',
        flavour: 'dweb',
        dojObj:dateObject ,
        src_name:src,
        dest_name:dest,
        offsetDate: offsetDate ? +offsetDate : 0,
        busType:busType && busType.length ? busType.split("|") : [],
        others:function(){
          if(others){
            return JSON.parse(others);
          }
        }()
      }))
      
    },
    actionsBeforeRenderOnServer: ({state, params, searchString}) => {
    },
    criticalApiPreFetch: () => {},
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {},
    responseHeader: {},
    isHotjarEnabled: true,
    exact: true,
    showFooter:true,
    enableAdtech:true,
    stickyHeader:true,
    enableVWO:true,
    fillStoreOnServer:async({state,localData})=>{ 
    const faq = await fetchFAQData();
    const {isLoading, isError, data} = faq;
    const footerResponse = await fillFooterStoreFromServer();
    return [
        updateFooterData({
          footer:footerResponse
        }),
        updateFAQDATA({isLoading:isLoading,isError:isError,data:data})
      ]
     },
  cacheConfig: {
      getCacheKey: ({params, searchString}) => {
        return ''
      },
      redisConfig: redisConfig,
    },
    fillStoreWaitTime:100000,
    toBeCached: true



  },
  {
    path: ['/sbus/search/','/bus/search/'],
    component: SearchResultPage,
    key: 'SearchResultPage',
    showFooter:true, 
    enableAdtech:true,
    stickyHeader:false,
    enableVWO:true,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      populateStoreFromUrlforSrp({params, searchString}, dispatch);
    },
    actionsBeforeRenderOnServer: ({state, params, searchString}) => {
    
    },
  
    criticalApiPreFetch: () => {},
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {},
    responseHeader: {},
    isHotjarEnabled: true,
    exact: true,
    fillStoreOnServer:async({state,localData})=>{ 
      const footerResponse = await fillFooterStoreFromServer();
      return [
          updateFooterData({
            footer:footerResponse
          })
        ]
     },
  cacheConfig: {
      getCacheKey: ({params, searchString}) => {
        return ''
      },
      redisConfig: redisConfig,
    },
    fillStoreWaitTime:100000,
    toBeCached: true

  },
  {
    path: ['/sbus/alternateroutes/','/bus/alternateroutes/'],
    component: AlternateRoutesUI,
    key: 'AlternateRoutesUIPage',
    showFooter:true, 
    enableAdtech:true,
    stickyHeader:false,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      populateStoreFromUrlforSrp({params, searchString}, dispatch);
     
    },
    actionsBeforeRenderOnServer: ({state, params, searchString}) => {
   
    },
  
    criticalApiPreFetch: () => {},
    toBeSSRed: true,
    isModal: false,
    fillStore: () => {},
    responseHeader: {},
    isHotjarEnabled: true,
    exact: true,
    fillStoreOnServer:async({state,localData})=>{ 
      const footerResponse = await fillFooterStoreFromServer();
      return [
          updateFooterData({
            footer:footerResponse
          })
        ]
     },
  cacheConfig: {
      getCacheKey: ({params, searchString}) => {
        return ''
      },
      redisConfig: redisConfig,
    },
    fillStoreWaitTime:100000,
    toBeCached: true

  },
  {
    path: ['/sbus/review/','/bus/review/'],
    component: Review,
    key: 'Review',
    exact: true,
    stickyHeader:false,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      try{
      var querydata = getQueryString('querydata',searchString);
      const queryParams = querydata ?  decodeURIComponent(querydata).split("-") : [];
    
      
    //  querydata=0bus-1Bhubaneswar-2Baripada-320200805-4-15-06-07-86055181608245179114-91874799524243259710
        let doj=queryParams[3];
        const queryDate = format_BusQueryDate(queryParams[3]);
       
        let searchDateObj = format_dateObj({keyName:'searchDate',value:queryDate})
       
       
       
        dispatch(updateJourneyParams({
          src:queryParams[1],
          dest:queryParams[2],
          src_vid: queryParams[8],
          dest_vid:queryParams[9],
          doj:doj,
          journeyType: 'onw',
          flavour: 'dweb',
          dojObj: searchDateObj['searchDateRaw'],
          src_name:queryParams[1],
          dest_name:queryParams[2]
      
        }))
      }catch(err){
     
      }
    },
    fillStoreOnServer:async({state,localData})=>{ 
      const footerResponse = await fillFooterStoreFromServer();
      return [
          updateFooterData({
            footer:footerResponse
          })
        ]
       },
    cacheConfig: {
        getCacheKey: ({params, searchString}) => {
          return ''
        },
        redisConfig: redisConfig,
      },
      responseHeader: {},
      isHotjarEnabled: true,
      showFooter:true,
      enableAdtech:false,
      fillStoreWaitTime:100000,
      toBeCached: true
  },
  {
    path: ['/bus/thankyou/'],
    component: ThankyouPage,
    key: 'ThankyouPage',
    showFooter:false, 
    enableAdtech:true,
    stickyHeader:false,
    thankyouPage:true,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
     
      const urlstr = decodeURIComponent(searchString);


      let flavour = getQueryString('flavour',urlstr);
      let payment = getQueryString('payment',urlstr)
      var trn = getQueryString('trn',urlstr);
      var vertical_txn_id = getQueryString('vertical_txn_id',urlstr);
      let pay_txn_id = getQueryString('pay_txn_id',urlstr);
      let pay_session_id = getQueryString('pay_session_id',urlstr);
      let pay_status = getQueryString('pay_status',urlstr);
      let request_id = getQueryString('request_id',urlstr);
      let pg = getQueryString('pg',urlstr);
      let format = getQueryString('format',urlstr);
      dispatch(updateThankyouPageURLParams({
        flavour,
        payment,
        trn,
        vertical_txn_id,
        pay_txn_id,
        pay_session_id,
        pay_status,
        request_id,
        pg,
        format

      }))
    
    },
    actionsBeforeRenderOnServer: ({state, params, searchString}) => {
   
    },
  
    criticalApiPreFetch: () => {},
    toBeSSRed: false,
    isModal: false,
    fillStore: () => {},
    responseHeader: {},
    isHotjarEnabled: false,
    enableExternalDependency:false,
    exact: true,
    fillStoreOnServer:async({state,localData})=>{ 
      const footerResponse = await fillFooterStoreFromServer();
      return [
          updateFooterData({
            footer:footerResponse
          })
        ]
     },
  cacheConfig: {
      getCacheKey: ({params, searchString}) => {
        return ''
      },
      redisConfig: redisConfig,
    },
    fillStoreWaitTime:100000,
    toBeCached: false

  }
];

function populateStoreFromUrlforSrp ({params, searchString}, dispatch) {
  const urlstr = decodeURIComponent(searchString);


  var bid = getQueryString('bid',urlstr);
  var routeId = getQueryString('routeid',urlstr)
  var rtcId = getQueryString('rtcId',urlstr);
  var sortBy = getQueryString('sortBy',urlstr);
  let others = getQueryString('others',urlstr);
  let offsetDate = getQueryString('offsetDate',urlstr);
  let src = getQueryString('src',urlstr);
  let dest = getQueryString('dest',urlstr);
  let src_id = getQueryString('src_id',urlstr);
  let dest_id = getQueryString('dest_id',urlstr);
  let onwDate = getQueryString('onwDate',urlstr);
  
  
  const queryParams = bid ?  decodeURIComponent(bid).split("-") : [];
  dispatch(updateRouteId(routeId));
  if(rtcId !== null && rtcId && rtcId.length){
     dispatch(updateRTCView(rtcId));

  }
  if(sortBy !== null && sortBy && sortBy.length){
   

  dispatch(updateSortBy(sortBy));
    
  }
  if (tvcQueryParameters({ key: 'utm_source', location: urlstr })) {
    //https://www.goibibo.com/bus/#bus-Chennai-Bangalore-20200611---0-0-4354390963378411938-6771549831164675055/
   // https://www.goibibo.com/bus/#bus-Chennai-Bangalore-NA---0-0-4354390963378411938-6771549831164675055/
   
   /*
   Purposed URl:- 
   https://www.goibibo.com/bus/search?bid=bus-Chennai-Bangalore-20200611---0-0-4354390963378411938-6771549831164675055&utm_source="chrome"
   https://www.goibibo.com/bus/search?bid=bus-Chennai-Bangalore-NA---0-0-4354390963378411938-6771549831164675055&utm_source="chrome"

   */ 
   
   /*
      check if landing on BusHome, or redirecting to SRP
      based on the existing URL patterns, after # can contain either page link like #home
      or #bus-Bangalore-Hyderabad-NA---0-0-6771549831164675055-2162254155836171767 for redirecting to SRP
      Splitting by '/', checking first component if it has searchQuery data, else stay user on BusHome
    */
    /**
     * if starting with #bus- then URL is for redirecting to SRP
     */
    let dateFromQryParam = queryParams[3] || onwDate;
    let doj=dateFromQryParam;
    let searchDateObj = {}
    const currentDateObj =format_dateObj({keyName:'currentDate',value:dateformat(getDateObj(),'yyyy-mm-dd')})
   
    if(dateFromQryParam !== 'NA'){

    
    const queryDate = format_BusQueryDate(dateFromQryParam);
     searchDateObj = format_dateObj({keyName:'searchDate',value:queryDate})
    }

    if(dateFromQryParam === 'NA'  || searchDateObj['searchDateRaw'].getTime() < currentDateObj['currentDateRaw'].getTime()){
      doj = dateformat(currentDateObj['currentDateRaw'],'yyyymmdd');
    searchDateObj = format_dateObj({keyName:'searchDate',value:format_BusQueryDate(doj)});
    }
    const {dateStr,dateObject } = function(){
      let dateObj =  searchDateObj['searchDateRaw'];
      if(offsetDate && Number.isInteger(+offsetDate) && +offsetDate > 0){
      
        dateObj.setDate(dateObj.getDate() + (+offsetDate));
      }
      return {dateStr:dateformat(dateObj,'yyyymmdd'),dateObject:dateObj};
    }()
   
    //if doj is for past date then we will show him today date data.
    dispatch(updateJourneyParams({
      src:queryParams[1] || src,
      dest:queryParams[2] || dest,
      src_vid: queryParams[8] || src_id,
      dest_vid:queryParams[9] || dest_id,
      doj:dateStr,
      journeyType: 'onw',
      flavour: 'dweb',
      dojObj: dateObject,
      src_name:queryParams[1] || src,
      dest_name:queryParams[2] || dest,
      others:function(){
        if(others){
          return JSON.parse(others);
        }
      }()
  
    }))
 
   return;
  }

  //bid=bus-Jamnagar-Rajkot-20200610---0-0-2990227504820572234-7030802527799619237





    
    let doj=queryParams[3] || onwDate;
    const queryDate = format_BusQueryDate(queryParams[3] || onwDate);
   
    let searchDateObj = format_dateObj({keyName:'searchDate',value:queryDate})
   
    const currentDateObj =format_dateObj({keyName:'currentDate',value:dateformat(getDateObj(),'yyyy-mm-dd')})
   
    //if doj is for past date then we will show him today date data.
    if(searchDateObj['searchDateRaw'].getTime() < currentDateObj['currentDateRaw'].getTime()){
   
      doj = dateformat(currentDateObj['currentDateRaw'],'yyyymmdd');
   
      searchDateObj = format_dateObj({keyName:'searchDate',value:format_BusQueryDate(doj)});
   
    }
    const {dateStr,dateObject } = function(){
      let dateObj =  searchDateObj['searchDateRaw'];
      if(offsetDate && Number.isInteger(+offsetDate) && +offsetDate > 0){
      
        dateObj.setDate(dateObj.getDate() + (+offsetDate));
      }
      return {dateStr:dateformat(dateObj,'yyyymmdd'),dateObject:dateObj};
    }()
   
    dispatch(updateJourneyParams({
      src:queryParams[1] || src,
      dest:queryParams[2] || dest,
      src_vid: queryParams[8] || src_id,
      dest_vid:queryParams[9] || dest_id,
      doj:dateStr,
      journeyType: 'onw',
      flavour: 'dweb',
      src_name:queryParams[1] || src,
      dest_name:queryParams[2] || dest,
      dojObj: dateObject,
      others:function(){
        if(others){
          return JSON.parse(others);
        }
      }()
    }))
 
  }
async function fetchFooterData(){
  try{

  
  const data =  await setVerticalFooterDataFromPageRover('bus');
  const cacheKey = getfooterRedisKey(); 
  setKeyForRedis({key: cacheKey, value: JSON.stringify(data)}, redisConfig);
 return data;
  }catch(err){
    pushDataToNewrelicFromServer(`busdwebfunnel=true&value=failure&key=footerfetch}`);
   
  }
}

async function fillFooterStoreFromServer(){
  try {

  
  const key = getfooterRedisKey();
  let footerResponse = await getKeyFromRedis({key: key}, redisConfig);
  if(!footerResponse){
     footerResponse= await fetchFooterData();
 
    }else{
      footerResponse = JSON.parse(footerResponse);
    }
    return footerResponse;
  }catch(err){
    pushDataToNewrelicFromServer(`busdwebfunnel=true&value=failure&key=footer}`);
  
    console.log(err);

  }     
}
